
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="ChatServiceSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 26"><path stroke="#fff" stroke-width="2" d="M12.25 1.223h3.5c2.94 0 5.759 1.223 7.837 3.4 2.079 2.178 3.246 5.131 3.246 8.21v0c0 3.08-1.167 6.034-3.246 8.211-2.078 2.178-4.897 3.4-7.837 3.4H2.275c-.294 0-.576-.121-.784-.34a1.19 1.19 0 01-.324-.82v-10.45c0-3.08 1.167-6.033 3.246-8.21 2.079-2.178 4.898-3.401 7.837-3.401v0z"/><circle cx="9.333" cy="12.833" r="1.167" fill="#fff" transform="rotate(-180 9.333 12.833)"/><circle cx="14" cy="12.833" r="1.167" fill="#fff" transform="rotate(-180 14 12.833)"/><circle cx="18.667" cy="12.833" r="1.167" fill="#fff" transform="rotate(-180 18.667 12.833)"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'ChatServiceSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
